module.exports = __webpack_public_path__ + "img/roteSpitze.494f1965.jpg";